import {FC} from 'react'
import {Container} from '@components/ui/container'
import {Assignment} from '@features/assignment/types.ts'
import {AssignmentHomesCards} from '@features/assignment/components/assignment-homes-cards'
import {AssignmentWalkthroughCards} from '@features/assignment/components/assignment-walkthrough-cards'

export const AssignmentContent: FC<{assignment: Assignment}> = ({assignment}) => {
    return (
        <Container className="h-fit py-8 px-0 md:py-12 md:px-8">
            {assignment.task_media.name == 'walkthrough' ? (
                <AssignmentWalkthroughCards assignment={assignment} />
            ) : (
                <AssignmentHomesCards assignment={assignment} />
            )}
        </Container>
    )
}
